// ─── AVATAR ASSET STORAGE CONFIGURATION ──────────────────────────────────────
// Central config for all avatar asset storage references.
// Import these constants everywhere instead of hardcoding bucket/version strings.

export const AVATAR_ASSET_BUCKET = 'avatar-assets';
export const AVATAR_ASSET_VERSION = 'v1';

/**
 * Build the storage path for an avatar asset.
 * @param {string} category - e.g. "eyes", "hair_styles"
 * @param {string} filename - e.g. "eyes_happy_blue.jpg"
 * @returns {string} - e.g. "v1/eyes/eyes_happy_blue.jpg"
 */
export const buildAssetStoragePath = (category, filename) =>
  `${AVATAR_ASSET_VERSION}/${category}/${filename}`;

/**
 * Supported image extensions for avatar asset uploads.
 */
export const AVATAR_ASSET_ALLOWED_EXTENSIONS = ['png', 'jpg', 'jpeg', 'webp'];

/**
 * Supported MIME types for avatar asset uploads.
 */
export const AVATAR_ASSET_ALLOWED_MIME = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
};
